import { Inject, Injectable, isDevMode } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthOIDCService } from './auth/authOIDC.service';
import { LoginService } from './login/login.service';
import { AppConfig, APP_CONFIG } from './shared-service/app.config';
import { BaseService } from './shared-service/base.service';
import { DataService } from './shared-service/data.service';
import { WindowRef } from './shared-service/windowRef.service';
import { DeeplinkService } from './deeplink/deeplink.service';

declare var $: any;


@Injectable()

export class AppService {
	status: string = 'Loading..';
	ua: string = this.winRef.nativeWindow.navigator.userAgent;
	switchAdminToLearnerUrl: string | any;
	constructor(
		private loginService: LoginService,
		private router: Router,
		private baseService: BaseService,
		private titleService: Title,
		private dataService: DataService,
		@Inject(APP_CONFIG) private config: AppConfig,
		// private keycloakService: KeycloakService,
		private authOIDCService: AuthOIDCService,
		private winRef: WindowRef,
		private deeplinkService: DeeplinkService
	) {
		baseService.loadConfig(config);
	}


	


	ngOnInitConfig() {
		this.switchAdminToLearnerUrl = sessionStorage.getItem('switchAdminToLearnerUrl');
		if (!this.switchAdminToLearnerUrl) {
			this.switchAdminToLearnerUrl = this.winRef.nativeWindow.location.href;
		}

		this.loginService.canUserLogin({}, "*****").then(async (res: any) => {

			if (res["CanLogin"] == false) {
				alert(res["Message"]);
				// document.location.href = `${this.baseService.config.authServerBaseUrl}realms/${this.baseService.config.realm}/protocol/openid-connect/logout?post_logout_redirect_uri=${this.baseService.config.lmsBaseUrl}learner&id_token_hint=${this.keycloakService.getKeycloakInstance().idToken}`;
				// this.baseService.logout();
				this.authOIDCService.logout();
				return;
			}

			let isLearnerSwitch = this.getParameterByName('isLearnerSwitch', this.switchAdminToLearnerUrl);
			if (isLearnerSwitch == "true") {
				this.baseService.isDirectLogin = false;
			}
			if (isLearnerSwitch != "true" && this.switchAdminToLearnerUrl) {
				if(
					this.getParameterByName("metadata", this.switchAdminToLearnerUrl) &&
					!await this.isCorrectDeepLinkDetails()
				){
					return;
				}

				const urlQueryPart = this.switchAdminToLearnerUrl.indexOf('?') > -1 ? this.switchAdminToLearnerUrl.substring(this.switchAdminToLearnerUrl.indexOf('?') + 1) : "";
				const urlHostPart = this.switchAdminToLearnerUrl.indexOf('?') > -1 ? this.switchAdminToLearnerUrl.substring(0, this.switchAdminToLearnerUrl.indexOf('?')) : this.switchAdminToLearnerUrl;
				let urlObj = new URL(this.switchAdminToLearnerUrl);
				// if (urlObj.port.trim().length == 0) 
				{
					const urlOriginPart = urlObj.origin + urlObj.pathname;
					let urlHashPart = new URL(urlHostPart).hash
					if (urlHashPart) {
						urlHashPart = urlHashPart.replace('#', '');
					}
					window.location.href = environment.lmsBaseUrl + "Default.aspx?isdeeplink=true&querypart=&" + urlQueryPart + "&origin=" + urlOriginPart + "&hashvalue=" + urlHashPart;
					return;
				}
			}

			let isProxyLogin = this.getParameterByName("isProxyLogin", this.switchAdminToLearnerUrl);
			
			// START OLD CODE
			if (this.getParameterByName("metadata", this.switchAdminToLearnerUrl)) {
				const isHash = new URL(this.switchAdminToLearnerUrl).hash;
				let metadata = this.switchAdminToLearnerUrl;
				if (isHash != "") {
					this.router.navigate(['/deeplink', { metadata }]);
				}
				else {
					// this.router.navigateByUrl(this.location.normalize(this.location.path()));
					this.router.navigateByUrl(this.switchAdminToLearnerUrl);
				}
			}
			else if (this.getParameterByName("isSpacedLearningLink", this.switchAdminToLearnerUrl)) {
				let jwt = this.getParameterByName("jwtToken", this.switchAdminToLearnerUrl);
				let corporateID: any = this.getParameterByName('corporateID', this.switchAdminToLearnerUrl);
				let courseLaunchId = this.getParameterByName('courseLaunchId', this.switchAdminToLearnerUrl);
				sessionStorage.setItem("corporateID", corporateID);
				let selectedUserRoleID: any = this.getParameterByName('selectedUserRoleID', this.switchAdminToLearnerUrl);
				let CultureCarrier: any = this.getParameterByName('selectedCulture', this.switchAdminToLearnerUrl);
				let userId = this.getParameterByName('userId', this.switchAdminToLearnerUrl);
				let nodeId = +this.getParameterByName('nodeId', this.switchAdminToLearnerUrl)!;
				if (CultureCarrier != "") {
					sessionStorage.setItem("selectedCulture", CultureCarrier);
					if (CultureCarrier == 'ar-AE') {
						$(".bodyClass").addClass('direction-rtl');
					} else {
						$(".bodyClass").removeClass('direction-rtl');
					}
				}

				const sResource = { "CorporateId": corporateID, "Culture": CultureCarrier };
				this.loginService.getStringResourceFromServer(sResource, this.config.storageResourcesKey).then((res) => {
					//lets set session storage
					sessionStorage.setItem("resource", JSON.stringify(res));
					this.baseService.loadStringResources(res);
					const spacedResource = { "UserId": userId, "jwtToken": jwt, "CourseLaunchId": courseLaunchId, "nodeId": nodeId };
					this.loginService.getJwtWiseUserSpacedLearningDetail(spacedResource, '*****').then((res: any) => {
						this.baseService.IsSpacedLearning = true;
						this.baseService.SpacedLaunchId = res['CourseLaunchId'];
						this.baseService.SpacedNodeId = nodeId;//res['NodeId'];

						setTimeout(() => {
							if (res['IsActiveCourse'] && res['IsActiveUser'] && !res['IsError']) {
								sessionStorage.setItem("user", "false");
								const body = { "jwtToken": jwt, "userName": "", "password": "", "IPAddress": "000.00.0.0", "deviceUUID": "", "corporateID": corporateID, "userID": userId };
								this.loginService.getJwtWiseLoginDetailFromServer(body, this.config.storageLoginKey, "existingLogin").then((res: any) => {
									//lets set session storage
									sessionStorage.setItem("user", JSON.stringify(res));
									this.baseService.loadUserAccount(res);
									this.baseService.setUserAtibuteLoded(true);
									this.baseService.userProfileImage = this.baseService.getUserAttr("UserImage");
									this.baseService.isActiveNotification = this.baseService.getUserAttr("isActiveNotification");
									this.titleService.setTitle(this.baseService.getUserAttr('ProductTitle'));
									//setting timer to check for session after just half of session time out duration
									this.dataService.startTimer(this.baseService.user["SessionTimeOut"]);
									//setting selected role id in session storage to show selected role id in nav bar
									sessionStorage.setItem("selectedUserRoleID", selectedUserRoleID);
									sessionStorage.setItem("selectedCulture", CultureCarrier);
									res['Culture'] = CultureCarrier;
									const sResource = { "CorporateId": res['CorporateId'], "Culture": res['Culture'] };
									this.loginService.getStringResourceFromServer(sResource, this.config.storageResourcesKey).then((res) => {
										//lets set session storage
										sessionStorage.setItem("resource", JSON.stringify(res));
										this.baseService.loadStringResources(res);
										this.router.navigate(['learner']);
										this.loginService.loginInAdminSite(spacedResource, 'test').then((res) => {
											console.log(res)
										}, (err) => {
											console.log(err);
										});
									}, (res) => {
									});

								}, (res) => {
								});

							}
							else if (!res['IsActiveUser']) {
								alert(this.baseService.getResource('rbkey_SpcLrnPrgrmBlckMsg'));
								this.baseService.logout();
							}
							else if (!res['IsActiveCourse']) {
								alert(this.baseService.getResource('rbkey_SpcLrnPrgrmExprdMsg'));
								this.baseService.logout();
							}
							else if (res['IsError']) {
								alert(this.baseService.getResource(res['ErrorMsgRbKey']));
								this.baseService.logout();
							}
						}, 500);


					}, (res) => {
					});
				}, (res) => {
				});


			}
			else {
				//Oh.. the screen is reloaded by end user or role/language is changed and location.reloaded is called
				if (sessionStorage.getItem("user") != null && sessionStorage.getItem("user") != "false") {

					let corporateID = sessionStorage.getItem("corporateID");
					let selectedUserRoleID = sessionStorage.getItem("selectedUserRoleID");
					let selectedCulture = sessionStorage.getItem("selectedCulture");

					let isLearnerSwitch = sessionStorage.getItem("isLearnerSwitch");


					let aspSessionId = this.getParameterByName('aspSessionId', this.switchAdminToLearnerUrl);
					const body = { "jwtToken": "", "userName": "", "password": "", "IPAddress": "000.00.0.0", "deviceUUID": "", "corporateID": corporateID, "aspSessionId": aspSessionId };

					//lets update data store as it will get empty on reload

					//user would be already logged in to the system from admin controller..
					//i just need to get the user account basis my JWT from the web API


					if (isLearnerSwitch == "true") {
						this.baseService.isDirectLogin = false;
						sessionStorage.setItem("isLearnerSwitch", "true");
					}
					else {
						sessionStorage.setItem("isLearnerSwitch", "false");
					}
					//if (!aspSessionId) {

					let params = {};
					if (isProxyLogin == "true") {
						params = {
							userName: this.getParameterByName('logonCode', this.switchAdminToLearnerUrl),
							corporateID: corporateID,
							IsProxyLogin: isProxyLogin
						}
					}

					this.loginService.getUserMoreDetails(params, this.config.storageLoginKey).then((res) => {
						this.setSessionStorage(res);
						this.setUserDetailsMoveToLearning(res);

					}, (res) => {
						this.router.navigate(['unauthorized', { date: new Date().getTime(), 'type': '1' }]);
					});
					// }
					// else {
					// 	this.loginService.getLoginDetailFromServer(body, this.config.storageLoginKey, "existingLogin").then((res) => {

					// 		this.baseService.isDirectLogin = false;
					// 		this.setUserDetailOnReload(res);
					// 	});
					// }

				}
				else {
					//let jwt = this.getCookie('jwt');
					//let LogOnCode = this.getCookie('LogOnCode');
					let corporateID: any = this.getParameterByName('corporateID', this.switchAdminToLearnerUrl);
					sessionStorage.setItem("corporateID", corporateID);
					let selectedUserRoleID: any = this.getParameterByName('selectedUserRoleID', this.switchAdminToLearnerUrl);
					sessionStorage.setItem("selectedUserRoleID", selectedUserRoleID);
					let aspSessionId = this.getParameterByName('aspSessionId', this.switchAdminToLearnerUrl);
					let CultureCarrier = this.getCookie('CultureCarrier') != '' ? this.getCookie('CultureCarrier') : sessionStorage.getItem("selectedCulture");
					if (!CultureCarrier) {
						CultureCarrier = 'en-US';
					}


					if (CultureCarrier != "") {
						//sessionStorage.setItem("selectedCulture", CultureCarrier);
						if (CultureCarrier == 'ar-AE') {
							$(".bodyClass").addClass('direction-rtl');
						} else {
							$(".bodyClass").removeClass('direction-rtl');
						}
					}

					let isLearnerSwitch = this.getParameterByName('isLearnerSwitch', this.switchAdminToLearnerUrl);
					if (isLearnerSwitch == "true") {
						this.baseService.isDirectLogin = false;
						sessionStorage.setItem("isLearnerSwitch", "true");
					}
					else {
						sessionStorage.setItem("isLearnerSwitch", "false");
					}
					//if (!aspSessionId) {
					sessionStorage.setItem("user", "false");

					let params = {};
					if (isProxyLogin == "true") {
						params = {
							userName: this.getParameterByName('logonCode', this.switchAdminToLearnerUrl),
							corporateID: corporateID,
							IsProxyLogin: isProxyLogin
						}
					}
					//user would be already logged in to the system from admin controller..
					//i just need to get the user account basis my JWT from the web API
					this.loginService.getUserMoreDetails(params, this.config.storageLoginKey).then((res) => {
						this.setSessionStorage(res);
						this.setUserDetailsMoveToLearning(res);
					}, (res) => {
						this.router.navigate(['unauthorized', { date: new Date().getTime(), 'type': '2' }]);
					});
					// }
					// else {

					// 	this.baseService.isDirectLogin = false;
					// 	sessionStorage.setItem("user", "false");

					// 	sessionStorage.setItem("selectedUserRoleID", selectedUserRoleID);

					// 	const body = { "jwtToken": jwt, "userName": LogOnCode, "password": "", "IPAddress": "000.00.0.0", "deviceUUID": "", "corporateID": corporateID, "aspSessionId": aspSessionId };

					// 	//user would be already logged in to the system from admin controller..
					// 	//i just need to get the user account basis my JWT from the web API
					// 	this.loginService.getLoginDetailFromServer(body, this.config.storageLoginKey, "existingLogin").then((res) => {


					// 		this.setUserDetailsMoveToLearning(res);



					// 	}, (res) => {
					// 	});
					// }
				}
			}

		}, (res) => {
		});


	}


	setSessionStorage(res: any) {
		if (res["LearnerRole"] == 0) {
			this.router.navigate(['unauthorized', { date: new Date().getTime(), 'type': '3' }]);
			return;
		}


		let corporateID: any = sessionStorage.getItem("corporateID");
		if (corporateID != res["CorporateId"]) {
			sessionStorage.removeItem("corporateID");
			sessionStorage.removeItem("selectedUserRoleID");
			sessionStorage.removeItem("selectedCulture");
			corporateID = undefined;
		}


		let selectedUserRoleID: any = sessionStorage.getItem("selectedUserRoleID");
		if (!selectedUserRoleID || selectedUserRoleID == "null")
			selectedUserRoleID = res["LearnerRole"];


		if (!corporateID || corporateID == "null")
			corporateID = res["CorporateId"];

		let selectedCulture: any = sessionStorage.getItem("CultureCarrier");
		if (!selectedCulture || selectedCulture == "null")
			selectedCulture = res["CultureCarrier"];

		sessionStorage.setItem("corporateID", corporateID);
		sessionStorage.setItem("selectedUserRoleID", selectedUserRoleID);
		sessionStorage.setItem("selectedCulture", selectedCulture);
	}

	setUserDetailOnReload(res: any) {
		//lets set session storage
		sessionStorage.setItem("user", JSON.stringify(res));
		this.baseService.loadUserAccount(res);
		this.baseService.setUserAtibuteLoded(true);

		this.baseService.userProfileImage = this.baseService.getUserAttr("UserImage");
		this.baseService.isActiveNotification = this.baseService.getUserAttr("isActiveNotification");
		this.titleService.setTitle(this.baseService.getUserAttr('ProductTitle'));
		if (this.baseService.isActiveNotification) {
			this.baseService.NotificationClass = "active";
			this.baseService.AnnouncementClass = "";
		}
		else {
			this.baseService.NotificationClass = "";
			this.baseService.AnnouncementClass = "active";
		}


		this.dataService.setStoreData(this.config.storageLoginKey, JSON.parse(sessionStorage.get00Item("user")));
		this.dataService.setStoreData(this.config.storageResourcesKey, JSON.parse(sessionStorage.getItem("resource")!));
		// this.baseService.loadUserAccount(JSON.parse(sessionStorage.getItem("user")));
		this.baseService.loadStringResources(JSON.parse(sessionStorage.getItem("resource")!));


		//setting timer to check for session after just half of session time out duration
		this.dataService.startTimer(this.baseService.user["SessionTimeOut"]);

		//TBC....
		let jwt = "";
		if (isDevMode()) {
			jwt = this.getCookie('jwt');
		}
		let LogOnCode = this.getCookie('LogOnCode');
		let CultureCarrier = this.getCookie('CultureCarrier');
		if (CultureCarrier != "") {
			sessionStorage.setItem("selectedCulture", CultureCarrier);
			if (CultureCarrier == 'ar-AE') {
				$(".bodyClass").addClass('direction-rtl');
			} else {
				$(".bodyClass").removeClass('direction-rtl');
			}
		}
		this.baseService.setUserAttr("Culture", sessionStorage.getItem("selectedCulture"));

		//now lets set culture..may be some one has changed that
		if (sessionStorage.getItem("selectedCulture") != null) {

			//good to have that local string resources data refreshed from server
			//ab:todo - need to remove hardcoding of corporateid
			this.loginService.getStringResourceFromServer({ "CorporateId": 1, "Culture": sessionStorage.getItem("selectedCulture") }, this.config.storageResourcesKey).then((res) => {

				//lets update that data in session store as well...TBC really required
				sessionStorage.setItem("resource", JSON.stringify(res));

				this.baseService.loadStringResources(res);
				this.router.navigate(['learner']);
			}, (res) => {
			}

			);
		} else {

			//TBC....
			//Todo:ab -going to same location from wher we switched from learner earlier is not working as of now will check later
			if (sessionStorage.getItem("location") != null && (jwt != null && jwt != 'undefined' && jwt != '')) {
				//this.router.navigateByUrl(sessionStorage.getItem("location"));
				this.router.navigate(['learner']);
			}
			else {
				//this.router.navigateByUrl(this.location.normalize(this.location.path()));					
				this.router.navigate(['learner']);
			}
		}

	}

	setUserDetailsMoveToLearning(res: any) {
		//lets set session storage
		sessionStorage.setItem("user", JSON.stringify(res));
		this.baseService.loadUserAccount(res);
		this.baseService.setUserAtibuteLoded(true);
		this.baseService.userProfileImage = this.baseService.getUserAttr("UserImage");
		this.baseService.isActiveNotification = this.baseService.getUserAttr("isActiveNotification");

		this.titleService.setTitle(this.baseService.getUserAttr('ProductTitle'));
		//setting timer to check for session after just half of session time out duration
		this.dataService.startTimer(this.baseService.user["SessionTimeOut"]);
		if (sessionStorage.getItem('selectedCulture') != '') {
			//sessionStorage.setItem("selectedCulture", this.getCookie('CultureCarrier'));
			res['Culture'] = sessionStorage.getItem('selectedCulture');
		}
		else if (res['CultureCarrier'] != null && res['CultureCarrier'] != undefined) {
			sessionStorage.setItem("selectedCulture", res['CultureCarrier']);
			res['Culture'] = res['CultureCarrier'];
		}

		this.dataService.setStoreData(this.config.storageLoginKey, res);

		const sResource = { "CorporateId": res['CorporateId'], "Culture": res['Culture'] };
		this.loginService.getStringResourceFromServer(sResource, this.config.storageResourcesKey).then((resData: any) => {

			//lets set session storage
			sessionStorage.setItem("resource", JSON.stringify(resData));

			this.baseService.loadStringResources(resData);

			this.dataService.setStoreData(this.config.storageResourcesKey, resData);

			this.router.navigate(['learner']);

		}, (res) => {
		});
	}

	getParameterByName(name: any, url = this.winRef.nativeWindow.location.href) {

		name = name.replace(/[\[\]]/g, "\\$&");
		var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	};

	getCookie(cname: any) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(this.winRef.nativeWindow.document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}


	navigatetoLastHistory() {
		if (sessionStorage.getItem("location") != null && sessionStorage.getItem("location")!.toString().indexOf("/learner/learning/container") == 0) {
			this.router.navigate([sessionStorage.getItem("location")]);
		}
		else {
			this.router.navigate(['learner']);
		}
	};

	routeTo(path: string, params: object, menuItem: string) {
		$('.sub-header').show();
		$('body').removeClass('offsidebar-open');
		if (menuItem == 'M' || menuItem == 'H') {
			this.baseService.setCurrentModulePath(this.baseService.loadModulePath('my_lrng_mdl'));
		}
		this.router.navigate([path, params]).then((res) => {
			console.log(res);
		});
		this.baseService.activateMenuItem(menuItem);
	}

	isCorrectDeepLinkDetails() {
		const params = {
		  DeeplinkUrl: sessionStorage.getItem("switchAdminToLearnerUrl"),
		};

		return new Promise((resolve, rejected) => {
		  return this.deeplinkService
			.getDeeplinkDetailFromServer(params, this.config.storageResourcesKey)
			.then((res: any) => {			 
			  const { LearningItemDetail } = res;
			  if (
				LearningItemDetail["CanAccess"] == false ||
				LearningItemDetail["IsValidUser"] == false
			  ) {
				alert(LearningItemDetail["ValidationMessage"]);
				resolve(false);
			  }
			resolve(true);
			});
		});
	}
	  

}
